import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import withAuth from "@helpers/withAuth";
import Layout from "@components/Layout";
import AppLoginScreen from "@screens/AppLogin";
import { isSupervisor } from "@helpers/index";
import { selectCurrentRole } from "@store/user/userSelectors";
import useAppSelector from "@hooks/useAppSelector";

const AppLoginContainer: React.FC = () => {
  const navigate = useNavigate();
  const role = useAppSelector(selectCurrentRole);

  useEffect(() => {
    if (role && !isSupervisor(role)) navigate("/");
  }, [role, navigate]);

  return (
    <Layout active="app-login">
      <AppLoginScreen />
    </Layout>
  );
};

export default withAuth(AppLoginContainer);
